import { fork } from 'redux-saga/effects';

import api from 'api';

import auth from './auth';
import profile from './profile';
import outlet from './outlet';

import { SagaForkReturnType } from './types';

const apiInstance = api;

export default function* root(): SagaForkReturnType {
    yield fork(auth(apiInstance.auth).rootSaga);
    yield fork(profile(apiInstance.profile).rootSaga);
    yield fork(outlet(apiInstance.outlet).rootSaga);
}
